import { render, staticRenderFns } from "./tableone.vue?vue&type=template&id=674d5739&scoped=true"
import script from "./tableone.vue?vue&type=script&lang=js"
export * from "./tableone.vue?vue&type=script&lang=js"
import style0 from "./tableone.vue?vue&type=style&index=0&id=674d5739&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d5739",
  null
  
)

export default component.exports